module.exports = __webpack_public_path__ + "img/aboutItem_2_img.b13dd827.png";